import { Button } from '@brokerbay/design-components';
import { Tooltip } from 'components';
import React, { ReactNode } from 'react';

interface CopyButtonProps {
  textToCopy: string;
  children?: ReactNode;
  dataCy?: string;
}
const CopyButton = ({ children, textToCopy, dataCy }: CopyButtonProps) => {
  const [isToolTipVisible, setIsToolTipVisible] = React.useState<boolean>();

  const copyToClipboard = (url: string) => {
    const TOOL_TIP_DURATION_MS = 1000;
    setIsToolTipVisible(true);
    setTimeout(() => setIsToolTipVisible(false), TOOL_TIP_DURATION_MS);
    navigator.clipboard.writeText(url);
  };

  return (
    <Tooltip
      open={isToolTipVisible}
      arrowPointAtCenter
      title="Link copied to clipboard"
      trigger="click"
    >
      <Button
        type="link"
        onClick={() => copyToClipboard(textToCopy)}
        data-cy={dataCy || 'copy-button'}
      >
        {children || 'Copy link'}
      </Button>
    </Tooltip>
  );
};

export default CopyButton;
